module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("German Girls")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#part-1-august-1978-swanage-dorset"
    }
  }, [_vm._v("Part 1 August 1978 Swanage,\n          Dorset")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#saturday"
    }
  }, [_vm._v("Saturday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday"
    }
  }, [_vm._v("Sunday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday"
    }
  }, [_vm._v("Monday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday"
    }
  }, [_vm._v("Tuesday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday"
    }
  }, [_vm._v("Wednesday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday"
    }
  }, [_vm._v("Thursday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday"
    }
  }, [_vm._v("Friday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-home-sunbury--on-thames"
    }
  }, [_vm._v("Saturday – Home –\n              Sunbury- on-Thames")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-back-at-work"
    }
  }, [_vm._v("Monday – Back at Work")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-the-grafton-hotel-swanage"
    }
  }, [_vm._v("Saturday – The Grafton\n              Hotel – Swanage")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-the-grafton-hotel"
    }
  }, [_vm._v("Sunday – The Grafton Hotel")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#part-2-september-1978-frankfurt-germany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2 September 1978\n          Frankfurt, Germany")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#the-boy-fun-flirt-club",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boy Fun Flirt Club")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#thursday-26th-october",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, 26"), _c('sup', [_vm._v("th")]), _vm._v("\n              October")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#frankfurt-germany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frankfurt, Germany")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#friday-27th-october",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, 27"), _c('sup', [_vm._v("th")]), _vm._v(" October")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#heathrow-airport-england",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heathrow Airport, England")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0